import moment from "moment";
import { useModuleEnabled } from "../../../../redux/selectors/modules";

// This should live in a more common place, but this is the first Typescript file in the project
const PC_STATUS = {
  PLANNED: "PLANNED",
  SUBMITTED: "SUBMITTED",
  ACCEPTED: "ACCEPTED",
  CONFIRMED: "CONFIRMED",
  REJECTED: "REJECTED",
  FAILED: "FAILED",
} as const;
type PC_STATUS = (typeof PC_STATUS)[keyof typeof PC_STATUS];

const maskDebugStatusMap: Record<PC_STATUS, string> = {
  PLANNED: "SUBMITTED",
  SUBMITTED: "SUBMITTED",
  ACCEPTED: "SUBMITTED",
  CONFIRMED: "ACCEPTED",
  REJECTED: "REJECTED",
  FAILED: "REJECTED",
};

interface Props {
  // One of these days react-table will be typed out
  value: string | null;
  original: {
    status: PC_STATUS;
  };
}

export const DateConfirmedCell = (props: Props) => {
  const isPriceDebug = useModuleEnabled("PRICE_DEBUG");
  const statusDisplay = isPriceDebug ? props.original.status : maskDebugStatusMap[props.original.status];

  return (
    <div className="pb-3">
      {props.value !== null ?
        <span>{moment(props.value).format("MMM DD YYYY, HH:mm")}</span>
      : <span>-</span>}
      <div>
        <small>
          {
            <>
              {([PC_STATUS.REJECTED, PC_STATUS.FAILED] as PC_STATUS[]).includes(props.original.status) && (
                <i className="pe-7s-attention pe-3 text-danger"></i>
              )}
              <span>{statusDisplay}</span>
            </>
          }
        </small>
      </div>
    </div>
  );
};
